import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Clickable } from 'phoenix-components';
import cx from 'classnames';
import { BottomDrawer } from 'components/shared/BottomDrawer';
import { selectIcon, unSelectIcon } from 'components/shared/Icons/Filters';
import { useLanguageLoader } from 'contexts/language';
import { Container } from 'components/layout/Container';
import styles from './Filters.module.css';
import { useQueryParams } from 'hooks/location';
import { safeJsonParse } from 'ui/lib/json';
import { useRouter } from 'next/router';

// const one = '/images/filters/one.svg';
// const oneS = '/images/filters/oneS.svg';
// const two = '/images/filters/two.svg';
// const twoS = '/images/filters/twoS.svg';
// const sel = '/images/filters/check.svg';
// const unsel = '/images/filters/uncheck.svg';

export default function Filters({
  // isMulti,
  // setIsMulti,
  catalog,
  setCatalog,
  all
}) {
  const lang = useLanguageLoader();
  const [openFilters, setOpenFilters] = useState(false);
  const [openSort, setOpensort] = useState(false);
  const [selected, setSelected] = useState(catalog || []);
  const params = useQueryParams();
  const router = useRouter();
  const sorts = safeJsonParse(params.get('sorts'), {});

  const isSelected = (item) => !!selected.find(x => x === item.caption);

  useEffect(()=>{
    setSelected(catalog || []);
  },[JSON.stringify(catalog)]);

  const onSortSelected = (val) => () => {
    if (sorts?.discountedAmount === val) {
      sorts.discountedAmount = undefined;
    } else {
      sorts.discountedAmount = val;
    }
    params.set('sorts', JSON.stringify(sorts));
    router.push({
      query: params.toString(),
    }, undefined, { shallow: true });
    setOpensort(false);
  };

  return (
    <div className={styles.filters}>
      <Container className={styles.container}>
        {openFilters && (
          <BottomDrawer
            title={lang('store.words.filters')}
            onClose={() => setOpenFilters(false)}
            closeButton={true}
          >
            <div className={styles.sec}>
              <div className={styles.head}>
                {lang('store.words.catalogs')}
              </div>
              <div className={styles.catalogs}>
                {all.map((x, i) => (
                  <div
                    key={i}
                    className={styles.catalog}
                    role="none"
                    onClick={() => {

                      if (isSelected(x)) {

                        const newCatalogs = selected.filter(y => y !== x.caption);
                        setSelected(newCatalogs);

                      } else {

                        setSelected([x.caption, ...selected]);

                      }

                    }}
                  >
                    {isSelected(x) ? selectIcon() : unSelectIcon()}
                    <span className={cx(styles.caption, { [styles.cS]: isSelected(x) })}>{x.caption}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.modalBtnSec}>
              <Button
                size="large"
                label={lang('buttons.clearFilters')}
                primary={false}
                className={styles.modalBtn}
                onClick={() => {

                  setCatalog([]);

                }}
              />
              <Button
                size="large"
                label={lang('buttons.apply')}
                className={styles.modalBtn}
                onClick={() => {

                  setCatalog(selected);
                  setOpenFilters(false);

                }}
              />
            </div>
          </BottomDrawer>
        )}
        {openSort && (
          <BottomDrawer
            title={lang('store.words.sort')}
            onClose={() => setOpensort(false)}
          >
            <div className={styles.sec1}>
              <div className={styles.rowC}>
                <Clickable onClick={onSortSelected(1)}>
                  <div className={styles.text}>
                    Price - low to high
                  </div>
                </Clickable>
                {sorts?.discountedAmount === 1 && (
                  <img
                    src="/images/product/selected.svg"
                    alt=""
                  />
                )}
              </div>
              <div className={styles.rowC}>
                <Clickable onClick={onSortSelected(-1)}>
                  <div className={styles.text}>
                    Price - high to low
                  </div>
                </Clickable>
                {sorts?.discountedAmount === -1 && (
                  <img
                    src="/images/product/selected.svg"
                    alt=""
                  />
                )}
              </div>
            </div>
          </BottomDrawer>
        )}
        <Clickable className={styles.filter} onClick={() => setOpenFilters(true)}>
          {lang('store.words.filters')}
          <span className={styles.primary}>{`(${catalog.length && catalog.length})`}</span>
        </Clickable>
        <Clickable className={styles.filter1} onClick={() => setOpensort(true)}>
          {lang('store.words.sort')}
          <span className={styles.primary}>{`(${Object.keys(sorts || {}).length})`}</span>
        </Clickable>
      </Container>
    </div>
  );

}

Filters.defaultProps = {
  isMulti: false,
  catalog: []
};

Filters.propTypes = {
  isMulti: PropTypes.bool,
  setIsMulti: PropTypes.func.isRequired,
  catalog: PropTypes.array,
  setCatalog: PropTypes.func.isRequired,
  all: PropTypes.array.isRequired,
};
